<template lang="pug">
  .center
    section.custom-width.margin-top
      el-row(:gutter="16")
        el-col(:xs="24", :sm="12", :md="12")
          .box-img
            img(data-aos="fade-right", data-aos-delay="700", :src="require('@/assets/svg/agencia.svg')")
        el-col(:xs="24", :sm="12", :md="12")
          h5.text-primary  Agência 2ED
          h2
            |Quem
            span.space
            span.text-secondary somos
          p 
           |A 
           strong Agência 2ED 
           |é uma agência de MARKETING DIGITAL voltada para o Lançamento de infoprodutos utilizando a Fórmula de Lançamento como estratégia. A partir da Fórmula de lançamento, técnica trazida ao Brasil por Erico Rocha, podemos alavancar produtos de parceiros e gerar um impacto positivo no mercado digital.
</template>

<script>
  export default {
    name: 'text-about',
    computed: {
      collapseMenu () {
        let self = this
        if (parseInt(self.$root.screenW) < 768) {
          return true
        }
        return false
      },
    },
  }
</script>

<style lang="sass" scoped>
  @import '../../assets/sass/bootloader'
  h5
    font-size: $f-size*1.1
  h2
    font-family: 'Kanit', sans-serif
  p
    margin: 64px 0
  .box-img
    img
      width: 100%
</style>